import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiFolder } from "react-icons/fi";

function Projects() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch("/data/projectsData.json")
      .then(response => response.json())
      .then(setProjects)
      .catch(() => setProjects([]));
  }, []);

  return (
    <section id="projects" className="section-shell">
      <div className="section-heading">
        <p className="section-title">Projects</p>
        <span className="section-icon" aria-hidden="true"><FiFolder /></span>
      </div>

      <div className="project-bento">
        {projects.map((project, index) => (
          <motion.a
            key={project.title || index}
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="project-bento-card group"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.45, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="project-bento-content">
              <h3 className="project-bento-title">
                {project.title}
              </h3>

              <p className="project-bento-copy">
                {project.details}
              </p>

              <div className="project-bento-action">
                <span>View project</span>
                <FiArrowUpRight aria-hidden="true" />
              </div>
            </div>

            {project.image && (
              <figure className="project-bento-image">
                <img
                  src={project.image}
                  alt={project.title}
                  loading="lazy"
                  decoding="async"
                  width="480"
                  height="280"
                  onError={event => { event.currentTarget.style.display = "none"; }}
                />
              </figure>
            )}
          </motion.a>
        ))}
      </div>
    </section>
  );
}

export default Projects;
